var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('div',{staticClass:"d-flex"},[_c('button',{staticClass:"btn btn-warning",on:{"click":function($event){return _vm.$modal.show(_vm.addManualEmailBounceModalName)}}},[_vm._v("\n        Eintrag hinzufügen\n      ")])]),_vm._v(" "),_c('table-filter',{attrs:{"filterComponents":[
        {
          type: 'WhereFilter',
          label: 'User-ID',
          attributes: 'user_id'
        },
        {
          type: 'WhereLikeFilter',
          label: 'E-Mail-Adresse',
          attributes: 'bounced_email_address'
        },
        {
          type: 'WhereLikeFilter',
          label: 'Name',
          attributes: 'profile_name'
        },
        {
          type: 'DateFilter',
          label: 'Datum von',
          attributes: { column: 'created_at', operator: '>=' }
        },
        {
          type: 'DateFilter',
          label: 'Datum bis',
          attributes: { column: 'created_at', operator: '<=' }
        }
      ]},on:{"apply-filters":function($event){return _vm.$bus.$emit('refresh-table')}},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_vm._v(" "),_c('v-table',{attrs:{"url":"/api/v1/emailBounce","filter":_vm.filter,"attributes":[
        {
          attribute: 'user_id',
          name: 'User-ID'
        },
        {
          attribute: 'profile_name',
          name: 'Name'
        },
        {
          attribute: 'bounced_email_address',
          name: 'problematische Email-Adresse'
        },
        {
          attribute: 'bounce_reason',
          name: 'Grund'
        },
        {
          attribute: 'created_at',
          name: 'Zurück gekommen am',
          type: 'DateTimeCell'
        },
        {
          value: 'customerProfile.id',
          name: 'Aktionen',
          type: 'BouncedEmailActionCell'
        }
      ]}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Zurückgekommene Emails")])])],1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('v-table',{attrs:{"url":"/api/v1/emailBounce","filter":[
          {
            name: 'sort',
            mode: 'DESC',
            attribute: 'updated_at'
          },
          {
            name: 'where',
            attributes: { restriction: true }
          }
        ],"attributes":[
          {
            attribute: 'user_id',
            name: 'User-ID'
          },
          {
            attribute: 'updated_at',
            name: 'Geblockt am'
          }
        ]}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Gesperrte Mitglieder (Emails)")])])],1),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('v-table',{attrs:{"url":"/api/v1/emailBounce","filter":[
          {
            name: 'sort',
            mode: 'DESC',
            attribute: 'updated_at'
          },
          {
            name: 'where',
            attributes: { restriction: false }
          }
        ],"attributes":[
          {
            attribute: 'user_id',
            name: 'User-ID'
          },
          {
            attribute: 'updated_at',
            name: 'Entsperrt am'
          }
        ]}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("Entsperrte Mitglieder (Emails)")])])],1)]),_vm._v(" "),_c('modal',{attrs:{"name":_vm.addManualEmailBounceModalName}},[_c('section',{staticClass:"p-3"},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('h2',[_vm._v("Email hinzufügen")])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.bounceAddress),expression:"bounceAddress"}],staticClass:"form-control",attrs:{"placeholder":"Email-Adresse ..."},domProps:{"value":(_vm.bounceAddress)},on:{"input":function($event){if($event.target.composing)return;_vm.bounceAddress=$event.target.value}}})]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button","disabled":_vm.disableModalActions},on:{"click":function($event){return _vm.addManualEmailBounce()}}},[_vm._v("\n        Hinzufügen\n      ")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }